import React from 'react';
import {JOB_STATUS_CATEGORY, JOB_STATUS_LABEL} from "../../types/models/Job.ts";
import {PulsingIcon} from "./PulsingIcon.tsx";
import {IPopulatedCutter, IPopulatedJob} from "../../types/FrontendTypes.ts";
import {ChipLine, SingleChipProps, StandardCardProps} from '@laser-project/kyui';
import {Circle, Help, Launch} from "@mui/icons-material";
import {CUTTER_STATUS} from "../../types/models/Cutter.ts";
import {Skeleton} from "@mui/material";

function getIconForCutter(cutter?: IPopulatedCutter, jobId?: string) {
    if (!cutter) {
        return <Help color={"warning"}/>;
    }

    if (cutter.status === CUTTER_STATUS.ONLINE) {
        if (cutter?.state.jobId === jobId) {
            return <PulsingIcon color={"success"}/>;
        }
        return <Circle color={"success"}/>;
    }
    return <Circle color={"error"}/>;
}

export function getCutterStateChip(cutter: IPopulatedCutter, jobId: string, truncate: boolean): StandardCardProps["chips"][0] & {
    id: string
} {
    return {
        id: 'cutter',
        label: cutter ? (truncate && cutter.name.length > 14 ? cutter.name.substring(0, 14) + '...' : cutter.name) : "Unassigned",
        props: {
            variant: "outlined",
            icon: getIconForCutter(cutter, jobId),
        }
    };
}

export function getJobStatusChip(job: IPopulatedJob): StandardCardProps["chips"][0] & { id: string } | null {
    if (!job.cutter && (JOB_STATUS_CATEGORY.CREATED).includes(job?.status)) {
        return null;
    }
    return {
        id: 'status',
        label: JOB_STATUS_LABEL[job.status],
    };
}

export function getModelLinkChip(job: IPopulatedJob): StandardCardProps["chips"][0] & { id: string } | null {
    if (!job.modelId) {
        return null;
    }
    if (job.modelId.origin === "KYUB") {
        return {
            id: 'link',
            label: "Kyub",
            props: {
                variant: "outlined",
                color: "secondary",
                icon: <Launch sx={{padding: 0.2}}/>,
                clickable: true,
            },
            onClick: () => {
                window.open("https://cursed.kyub.io/model/" + job.modelId.modelId, "_blank");
            }
        };
    }
    return null;
}

export function getJobStatusChips(job?: IPopulatedJob, truncate: boolean = false): (StandardCardProps["chips"][0] & {
    id: string
})[] {
    return [
        getCutterStateChip(job.cutter, job._id, truncate),
        ...(getJobStatusChip(job) ? [getJobStatusChip(job)] : []),
        ...(getModelLinkChip(job) ? [getModelLinkChip(job)] : []),
    ];
}

export function renderJobStatusChips(job?: IPopulatedJob, truncate: boolean = false) {
    if (!job) {
        return (<Skeleton width={300} height={30}/>);
    }

    const chips = getJobStatusChips(job, truncate) as unknown as SingleChipProps[];

    return (
        <ChipLine
            chips={chips}
        />
    );
}